import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  private regex: RegExp = new RegExp(/^[0-9]*$/);

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    const inputElement = this.el.nativeElement;

    if (!this.regex.test(inputElement.value)) {
      event.preventDefault();
      return;
    }

    if (!this.regex.test(key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)) {
      event.preventDefault();
    }

    if (key === 'Enter') {
      if (!this.regex.test(inputElement.value)) {
        event.preventDefault();
      }
    }
  }

  @HostListener('input', ['$event']) onInput(event: InputEvent) {
    const inputElement = this.el.nativeElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
